<div class="offer" *ngIf="openedDocument$ | async as openedDocument" >
    <div class="summary-title">
        <div class="summary-title__content">
            <ng-container *ngIf="+openedDocument.documentTypeId === documentTypes.complaint">
                {{ 'COMPLAINT|Obsługa zgłoszenia reklamacyjnego' | translate }}
            </ng-container>
            <ng-container *ngIf="+openedDocument.documentTypeId === documentTypes.service">
                {{ 'COMPLAINT|Obsługa zgłoszenia serwisowego' | translate }}
            </ng-container>
            <span> {{ openedDocument.documentNumber.join('') }}</span>
        </div>
        <div class="summary-title__actions">
            <button *ngIf="hasAccessTo.scheduleAppointment && !hasAccessTo.manageProtocolOnly && ((openedDocument.assignedTo && openedDocument.assignedTo.startsWith(getUserType())) || hasAccessTo.manageComplaintManufacturer)" class="appointments-button" iccButton appearance="outline" (click)="editAppointment(openedDocument); scrollToSection('appointments')">
                {{ 'COMPLAINT_APPOINTMENT|Zaplanuj wizytę' | translate }}  <icc-icon name="add"></icc-icon>
            </button>
            <button
                [disabled]="!hasAccessTo.manageComplaint || synced !== 'synced' || isComplaintAuthorCompany"
                iccButton
                appearance="outline"
                (click)="editComplaint(openedDocument)"
            >
                {{ 'COMPLAINT|Edytuj status i dane' | translate }} <icc-icon name="edit"></icc-icon>
            </button>
        </div>
    </div>

    <icc-complaint-summary
        [document]="openedDocument"
        [positionsWorkflowsGroups]="positionsWorkflowsGroups"
        [positions]="positions$ | async"
        [selectedPositions]="selectedPositions"
        [appointments]="appointments$ | async"
        [appointmentsAttachments]="appointmentAttachments$ | async"
        (complaintTypeChange)="changeComplaintType($event)"
        (clearSelectedPositions)="clearSelectedPositions()"
    ></icc-complaint-summary>

    <div class="complaint-navbar-wrapper">
        <div class="complaint-navbar">
            <div class="complaint-navbar__item">
                <button iccIconButton appearance="flat-base" (click)="scrollToTop()">
                    <icc-icon name="navigate_top"></icc-icon>
                </button>
            </div>

            <div class="complaint-navbar__item" (click)="scrollToSection('details')">
                {{ 'COMPLAINT|Szczegóły zgłoszenia' | translate }}
            </div>

            <div class="complaint-navbar__item" (click)="scrollToSection('appointments')">
                {{ 'COMPLAINT|Planowanie wizyt' | translate }}
            </div>

            <div *ngIf="getUserType() === 'manufacturer' || getUserType() === 'distributor'" class="complaint-navbar__item" (click)="scrollToSection('correction')">
                {{ 'COMPLAINT|Rekompensaty, korekty' | translate }}
            </div>

            <div class="complaint-navbar__item" (click)="scrollToSection('spare-parts')">
                {{ 'COMPLAINT|Użyte produkty' | translate }}
            </div>

            <div class="complaint-navbar__item" (click)="scrollToSection('tree')">
                {{ 'COMPLAINT|Drzewo obsługujących' | translate }}
            </div>

            <div class="complaint-navbar__item" (click)="scrollToSection('history')">
                {{ 'COMPLAINT|Historia zgłoszenia' | translate }}
            </div>
        </div>
    </div>

    <div class="section-header" id="details">
        <div class="section-header__title">
            {{ 'COMPLAINT|Szczegóły zgłoszenia' | translate }}
        </div>
    </div>

    <div class="product-elements" *ngIf="positions$ | async as positions" >
        <div class="positions-container">
            <ng-container *ngFor="let position of positions; index as id; trackBy: trackByPosition">
                <icc-complaint-position
                    *ngIf="position !== null && openedDocuments[position.documentId]"
                    [position]="position"
                    [showDetails]="positionsShowDetails.get(position.uuid)"
                    [positionTitle]="positionsTitles.get(position.uuid)"
                    [positionsCount]="positions.length"
                    [selectedPositionsCount]="selectedPositions.length"
                    [document]="openedDocuments[position.documentId]"
                    [attachments]="(attachments$ | async)?.get(position.uuid) || []"
                    [isComplaintAuthorCompany]="isComplaintAuthorCompany"
                    (showDetailsEvent)="switchShowDetails(position.uuid, $event)"
                    (selectPosition)="selectPosition($event)"
                    (unselectPosition)="unselectPosition($event)"
                    [id]="position.uuid"
                    [index]="id"
                ></icc-complaint-position>
            </ng-container>
        </div>
    </div>

    <div class="section-header borderless" id="appointments">
        <div class="section-header__title">
            {{ 'COMPLAINT_APPOINTMENT|Planowanie wizyt' | translate }}
        </div>
        <div class="section-header__actions">
            <button *ngIf="hasAccessTo.scheduleAppointment && !hasAccessTo.manageProtocolOnly && ((openedDocument.assignedTo && openedDocument.assignedTo.startsWith(getUserType())) || hasAccessTo.manageComplaintManufacturer)" class="appointments-button" iccButton appearance="outline" (click)="editAppointment(openedDocument)">
                {{ 'COMPLAINT_APPOINTMENT|Zaplanuj wizytę' | translate }}  <icc-icon name="add"></icc-icon>
            </button>
        </div>
    </div>

    <div class="product-elements" *ngIf="complaintAppointments?.length">
        <div class="appointments-container">
            <ng-container *ngFor="let appointment of complaintAppointments; index as id; trackBy: trackByAppointment">
                <icc-complaint-appointment
                    *ngIf="appointment !== null && openedDocuments[appointment.documentId]"
                    [appointment]="appointment"
                    [document]="openedDocuments[appointment.documentId]"
                    [attachments]="(appointmentAttachments$ | async)?.get(appointment.uuid) || []"
                    [id]="appointment.uuid"
                    [index]="id"
                    [positionsWorkflowsGroups]="positionsWorkflowsGroups"
                    class="appointments-container__item"
                ></icc-complaint-appointment>
            </ng-container>
        </div>
    </div>

    <div class="section-header" *ngIf="getUserType() === 'manufacturer' || getUserType() === 'distributor'" [class.borderless]="hasAccessTo.manageComplaint" id="correction">
        <div class="section-header__title">
            {{ 'COMPLAINT|Rekompensaty, korekty' | translate }}
        </div>
        <div class="section-header__actions">
            <button *ngIf="hasAccessTo.manageComplaint && activeUserCompanyId === openedDocument.manufacturerCompanyId" class="correction-button" iccButton appearance="outline" (click)="editCorrectionAndDiscount(openedDocument)">
                {{ 'COMPLAINT|Edytuj nr korekty i rabat' | translate }}<icc-icon name="edit"></icc-icon>
            </button>
        </div>
    </div>

    <div class="complaint-correction" *ngIf="getUserType() === 'manufacturer' || getUserType() === 'distributor'">
        <div class="complaint-correction__container">
            <div class="complaint-correction__container__labels">
                <span class="complaint-correction__label">
                    {{ 'COMPLAINT|Wystawiona korekta' | translate }}
                </span>
                <span class="complaint-correction__label">
                    {{ 'COMPLAINT|Numer korekty' | translate }}
                </span>
            </div>

            <div class="complaint-correction__container__values">
                <span class="complaint-correction__content__header" style="text-transform: uppercase;">
                    {{ openedDocument.correctionIssued ? ('INTERFACE|Tak' | translate) : ('INTERFACE|Nie' | translate) }}
                </span>
                <span class="complaint-correction__content__header">
                    {{ openedDocument.correctionNumber }}
                </span>
            </div>
        </div>

        <div class="complaint-correction__container">
            <div class="complaint-correction__container__labels">
                <span class="complaint-correction__label">
                    {{ 'COMPLAINT|Udzielony rabat' | translate }}
                </span>
            </div>

            <div class="complaint-correction__container__values">
                <span class="complaint-correction__content__header">
                    {{ (openedDocument.discount || 0) + ' PLN' }}
                </span>
            </div>
        </div>
    </div>

    <div class="section-header" [class.borderless]="hasAccessTo.manageSpareParts" id="spare-parts">
        <div class="section-header__title">
            {{ 'COMPLAINT_APPOINTMENT|Użyte produkty' | translate }}
        </div>
        <div class="section-header__actions">
            <button *ngIf="hasAccessTo.manageSpareParts" class="appointments-button" iccButton appearance="outline" (click)="manageComplaintSpareParts(openedDocument)">
                {{ 'COMPLAINT_SPARE_PART|Użyto produkty' | translate }}  <icc-icon name="add"></icc-icon>
            </button>
        </div>
    </div>

    <div *ngIf="productsList" class="complaint-spare-parts__container">
        <div class="complaint-spare-parts" *ngFor="let complaintSparePart of complaintSpareParts; index as i">
            <div class="complaint-spare-parts-card" *ngIf="!complaintSparePart.isDeleted">
                <div class="complaint-spare-parts-card__body">
                    <div class="complaint-spare-parts-card__details">
                        <span class="complaint-spare-parts-card__identifier">
                            <icc-icon name="date"></icc-icon>
                        </span>
                        <div class="complaint-spare-parts-card__details-info">
                            <div class="complaint-spare-parts-card__details-row__header">
                                <span class="complaint-spare-parts-card__company" [ngClass]="activeUserCompanyId === complaintSparePart.companyId ? 'fw-600' : ''">
                                    <span *ngIf="complaintSparePart.companyId === openedDocument.authorizedRetailer?.companyId">
                                        {{ openedDocument.authorizedRetailer?.companyName }}
                                    </span>
                                    <span *ngIf="complaintSparePart.companyId === openedDocument.distributor?.companyId">
                                        {{ openedDocument.distributor?.companyName }}
                                    </span>
                                    <span *ngIf="complaintSparePart.companyId === openedDocument.manufacturer?.companyId">
                                        {{ openedDocument.manufacturer?.companyName }}
                                    </span>
                                </span>
                            </div>

                            <div class="complaint-spare-parts-card__details-row">
                                <span class="complaint-spare-parts-card__date-used">
                                    {{ complaintSparePart.created | date: 'shortDate'}}
                                </span>

                                <span class="complaint-spare-parts-card__product-name" style="font-weight: 700;">
                                    {{ complaintSparePart.name || getProductName(complaintSparePart.productId) }}
                                </span>

                                <span class="complaint-spare-parts-card__quantity fw-700">
                                    {{ 'COMPLAINT_SPARE_PART|Ilość:' | translate }} {{ complaintSparePart.quantity }} {{ (getUnit(complaintSparePart.productId) | unit:complaintSparePart.quantity:true) }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="complaint-spare-parts-card__actions" *ngIf="activeUserCompanyId === complaintSparePart.companyId && hasAccessTo.manageSpareParts">
                        <button
                            iccButton
                            (click)="removeSparePartFromComplaint(complaintSparePart)"
                            [title]="'INTERFACE|Usuń' | translate"
                            appearance="outline"
                        >
                            <icc-icon name="delete"></icc-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-header" id="tree">
        <div class="section-header__title">
            {{ 'COMPLAINT|Drzewo obsługujących' | translate }}
        </div>
    </div>

    <div class="parties" [class.preview]="preview">
        <div class="parties-card_data" [class.preview]="preview">
            <span class="parties-card_data__label">
                {{ 'COMPLAINT|Reklamujący:' | translate }}
            </span>
            <div class="parties-card_data__content">
                <div class="parties-card_data__content-box">
                    <span class="parties-card_data__content-box__wrapper">
                        <div class="parties-card_data__content-box__header">
                            <span class="parties-card_data__content-box__company_name" *ngIf="openedDocument?.clientName">{{ openedDocument.clientName }}<br></span>
                            <span class="parties-card_data__content-box__company_name" *ngIf="!openedDocument?.clientName && authorizedRetailerDistributorComplaint">{{ 'COMPLAINT|APS' | translate }}<br></span>
                            <span class="parties-card_data__content-box__company_name" *ngIf="!openedDocument?.clientName && distributorManufacturerComplaint">{{ 'COMPLAINT|Dystrybutor' | translate }}<br></span>
                            <div class="parties-card_data__content-box__actions">
                                <button
                                    *ngIf="!preview && hasAccessTo.editComplainantData"
                                    iccIconButton
                                    [small]="true"
                                    appearance="flat"
                                    (click)="openComplainantDataDialog(openedDocument)"
                                    [disabled]="synced !== 'synced'"
                                    [title]="'INTERFACE|Edytuj' | translate"
                                    type="button"
                                >
                                    <icc-icon name="edit"></icc-icon>
                                </button>
                            </div>
                        </div>
                        <div class="parties-card_data__content-box__row">
                            <span *ngIf="openedDocument?.clientPhoneNumber">{{ 'CONTACT|tel.' | translate }} {{ openedDocument.clientPhoneNumber }}<br></span>
                            <span *ngIf="openedDocument.clientEmail">{{ openedDocument.clientEmail }}<br></span>
                            <div *ngIf="openedDocument?.installationAddress || openedDocument?.locationDescription">
                                <span class="parties-card_data__content-box__field-label">{{ 'COMPLAINT|Adres instalacji:' | translate }}</span>
                                <span *ngIf="openedDocument?.installationAddress">
                                    {{ openedDocument.installationAddress }}
                                    <span *ngIf="openedDocument.locationSource === 'manual'">({{ 'COMPLAINT|znacznik ustawiony ręcznie' | translate }})</span>
                                    <span *ngIf="openedDocument.locationPartialMatchConfirmed && openedDocument.locationSource !== 'manual'"> ({{ 'COMPLAINT|tylko częściowa zgodność adresu – pozycja znacznika potwierdzona przez Klienta' | translate }})</span>
                                </span>
                                <br *ngIf="openedDocument?.installationAddress">
                                <button
                                    *ngIf="openedDocument.latitude && openedDocument.longitude && apiLoaded"
                                    iccButton
                                    [small]="true"
                                    appearance="outline"
                                    (click)="openMapDialog(openedDocument)"
                                    type="button"
                                >
                                    {{ 'COMPLAINT|Przejdź do mapy' | translate }}
                                </button>
                                <br>
                            </div>
                            <div *ngIf="openedDocument?.locationDescription">
                                <span class="parties-card_data__content-box__field-label">{{ 'COMPLAINT|Opis lokalizacji:' | translate }}</span>
                                {{ openedDocument.locationDescription }}<br>
                            </div>
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div class="parties-card_data" [class.preview]="preview">
            <span class="parties-card_data__label">
                {{ 'COMPLAINT|Sprzedający (APS):' | translate }}
            </span>
            <div class="parties-card_data__content">
                <div class="parties-card_data__content-box" [class.currently-assigned]="openedDocument.assignedTo === 'authorizedRetailer'">
                    <span class="parties-card_data__content-box__wrapper">
                        <div class="parties-card_data__content-box__header">
                            <span class="parties-card_data__content-box__company_name" *ngIf="isDistributorAsAps">
                                {{ 'COMPLAINT|Dystrybutor = APS' | translate }}<br>
                            </span>
                            <span class="parties-card_data__content-box__company_name" *ngIf="openedDocument?.authorizedRetailer?.companyName && !isDistributorAsAps">{{ openedDocument.authorizedRetailer?.companyName }}<br></span>
                            <div class="parties-card_data__content-box__actions">
                                <button *ngIf="!preview && (openedDocument?.authorizedRetailerCompanyId && canChangeUser('authorizedRetailer') || canAttachAps) && !authorizedRetailerDistributorComplaint && !distributorManufacturerComplaint" iccIconButton [small]="true" appearance="flat" (click)="openChangeUserDialog('authorizedRetailer', openedDocument)" [title]="'INTERFACE|Zmień' | translate"
                                >
                                    <icc-icon name="edit"></icc-icon>
                                </button>
                                <button *ngIf="!preview && canDetachAps && openedDocument?.authorizedRetailer?.companyId && !authorizedRetailerDistributorComplaint && !distributorManufacturerComplaint" iccIconButton [small]="true" appearance="flat" (click)="detachAps(openedDocument)" [title]="'COMPLAINT|Odepnij APS' | translate"
                                >
                                    <icc-icon name="link_off"></icc-icon>
                                </button>
                                <button *ngIf="!preview && !distributorManufacturerComplaint && openedDocument?.authorizedRetailer?.companyId" iccIconButton [small]="true" appearance="flat" (click)="openUserPreviewDialog('authorizedRetailer', openedDocument)" [title]="'INTERFACE|Szczegóły' | translate">
                                    <icc-icon name="open"></icc-icon>
                                </button>
                            </div>
                        </div>

                        <div class="parties-card_data__content-box__row">
                            <span class="parties-card_data__content-box__company_name" *ngIf="openedDocument?.authorizedRetailer?.userId === null && openedDocument?.authorizedRetailer?.companyId === null && openedDocument?.authorizedRetailer?.referenceName && openedDocument?.authorizedRetailer?.companyName === ''">{{ openedDocument.authorizedRetailer?.referenceName }}<br></span>
                            <div class="parties-card_data__content-box__responsible_user">
                                <span *ngIf="openedDocument?.authorizedRetailer?.referenceName && openedDocument?.authorizedRetailer?.userId === null && openedDocument?.authorizedRetailer?.companyId === null">{{ 'COMPLAINT|Punkt sprzedaży - NIP:' | translate }} </span>
                                <span class="parties-card_data__content-box__name" *ngIf="openedDocument?.authorizedRetailer?.referenceName && openedDocument?.authorizedRetailer?.userId !== null && openedDocument?.authorizedRetailer?.companyId !== null">{{ openedDocument.authorizedRetailer?.referenceName }}<br></span>
                                <span *ngIf="openedDocument?.authorizedRetailer?.referenceName && openedDocument?.authorizedRetailer?.userId === null && openedDocument?.authorizedRetailer?.companyId === null">{{ openedDocument.authorizedRetailer?.companyVatNr }}<br></span>
                                <span *ngIf="openedDocument?.authorizedRetailer?.referenceName && openedDocument?.authorizedRetailer?.userId === null && openedDocument?.authorizedRetailer?.companyId === null"> {{ 'COMPLAINT|Punkt sprzedaży - adres:' | translate }} </span>
                                <span *ngIf="openedDocument?.authorizedRetailer?.referenceName && openedDocument?.authorizedRetailer?.userId === null && openedDocument?.authorizedRetailer?.companyId === null">{{ openedDocument.authorizedRetailer?.address }}<br></span>
                                <span *ngIf="openedDocument?.authorizedRetailer?.phoneNumber">{{ 'CONTACT|tel.' | translate }} {{ openedDocument.authorizedRetailer?.phoneNumber }}<br></span>
                                {{ openedDocument.authorizedRetailer?.email }}<br>
                            </div>
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div class="parties-card_data" [class.preview]="preview">
            <span class="parties-card_data__label">
                {{ 'COMPLAINT|Dystrybutor:' | translate }}
            </span>
            <div class="parties-card_data__content">
                <div class="parties-card_data__content-box" [class.currently-assigned]="openedDocument.assignedTo === 'distributor'">
                    <span class="parties-card_data__content-box__wrapper">
                        <div class="parties-card_data__content-box__header">
                            <span class="parties-card_data__content-box__company_name" *ngIf="openedDocument?.distributor?.companyName">{{ openedDocument.distributor?.companyName }}<br></span>
                            <div class="parties-card_data__content-box__actions">
                                <button *ngIf="!preview && canChangeUser('distributor') && !authorizedRetailerDistributorComplaint && !distributorManufacturerComplaint" [small]="true" iccIconButton appearance="flat" (click)="openChangeUserDialog('distributor', openedDocument)" [title]="'INTERFACE|Zmień' | translate"
                                >
                                    <icc-icon name="edit"></icc-icon>
                                </button>
                                <button *ngIf="!preview" [small]="true" iccIconButton appearance="flat" (click)="openUserPreviewDialog('distributor', openedDocument)" [title]="'INTERFACE|Szczegóły' | translate">
                                    <icc-icon name="open"></icc-icon>
                                </button>
                            </div>
                        </div>

                        <div class="parties-card_data__content-box__row">
                            <div class="parties-card_data__content-box__responsible_user">
                                <span class="parties-card_data__content-box__name" *ngIf="openedDocument?.distributor?.referenceName">{{ openedDocument.distributor?.referenceName }}<br></span>
                                <span *ngIf="openedDocument?.distributor?.phoneNumber">{{ 'CONTACT|tel.' | translate }} {{ openedDocument?.distributor?.phoneNumber }}<br></span>
                                {{ openedDocument?.distributor?.email }}<br>
                            </div>
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div class="parties-card_data" [class.preview]="preview">
            <span class="parties-card_data__label">
                {{ 'COMPLAINT|Producent:' | translate }}
            </span>
            <div class="parties-card_data__content">
                <div class="parties-card_data__content-box" [class.currently-assigned]="openedDocument.assignedTo === 'manufacturer'">
                    <span class="parties-card_data__content-box__wrapper">
                        <div class="parties-card_data__content-box__header">
                            <span class="parties-card_data__content-box__company_name" *ngIf="openedDocument?.manufacturer?.companyName">{{ openedDocument.manufacturer?.companyName }}<br></span>
                            <div class="parties-card_data__content-box__actions">
                                <button *ngIf="!preview" [small]="true" iccIconButton appearance="flat" (click)="openUserPreviewDialog('manufacturer', openedDocument)" [title]="'INTERFACE|Szczegóły' | translate">
                                    <icc-icon name="open"></icc-icon>
                                </button>
                            </div>
                        </div>

                        <div class="parties-card_data__content-box__row">
                            <div class="parties-card_data__content-box__responsible_user">
                                <span class="parties-card_data__content-box__name" *ngIf="openedDocument?.manufacturer?.referenceName">{{ openedDocument.manufacturer?.referenceName }}<br></span>
                                <span *ngIf="openedDocument?.manufacturer?.phoneNumber">{{ 'CONTACT|tel.' | translate }} {{ openedDocument.manufacturer?.phoneNumber }}<br></span>
                                {{ openedDocument.manufacturer?.email }}<br>
                            </div>
                        </div>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="section-header" [class.borderless]="hasAccessTo.addComplaintNote || hasAccessTo.addInternalNote || hasAccessTo.addPrivateNote" id="history">
        <div class="section-header__title">
            {{ 'COMPLAINT|Historia zgłoszenia' | translate }}
        </div>
        <div class="section-header__actions">
            <button *ngIf="hasAccessTo.addComplaintNote || hasAccessTo.addInternalNote || hasAccessTo.addPrivateNote" class="details-card-body-button-note" iccButton appearance="outline" (click)="createComplaintNote(openedDocument)">
                {{ 'COMPLAINT|Dodaj notatkę' | translate }}  <icc-icon name="add"></icc-icon>
            </button>
        </div>
    </div>

    <div class="history">
        <ng-container *ngIf="changesLoading">
            <div class="details-card">
                <div class="details-card-header"></div>
                <div class="details-card-body">
                    <div class="details-card-body-description">
                        {{ 'INTERFACE|Trwa ładowanie danych...' | translate }}
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="!changesLoading">
            <div class="history-tabs">
                <button
                    iccButton
                    [appearance]="activeHistoryTab === 'notes' ? 'primary' : 'secondary'"
                    [class.active]="activeHistoryTab === 'notes'"
                    (click)="activeHistoryTab = 'notes'"
                >
                    {{ 'COMPLAINT|Notatki' | translate }}
                </button>
                <button
                    iccButton
                    [appearance]="activeHistoryTab === 'system' ? 'primary' : 'secondary'"
                    [class.active]="activeHistoryTab === 'system'"
                    (click)="activeHistoryTab = 'system'"
                >
                    {{ 'COMPLAINT|Informacje systemowe' | translate }}
                </button>
                <button
                    iccButton
                    [appearance]="activeHistoryTab === 'all' ? 'primary' : 'secondary'"
                    [class.active]="activeHistoryTab === 'all'"
                    (click)="activeHistoryTab = 'all'"
                >
                    {{ 'COMPLAINT|Wszystkie' | translate }}
                </button>
            </div>

            <ng-container *ngFor="let change of filteredChanges; trackBy: trackByFunction">
                <div *ngIf="change.type === 'splitSeparator'" class="split-separator">
                    <span class="split-separator__text">{{ change.title }}</span>
                </div>
                <div *ngIf="change.type !== 'splitSeparator'" class="details-card" [ngClass]="{'note-entry': change.type === 'addComplaintNote', 'note-position-missing': isNotePositionMissing(change)}">
                    <div class="details-card__body" [ngClass]="{'note-position-missing': isNotePositionMissing(change)}">
                        <div class="details-card__details">
                            <div class="details-card__icon">
                                <icc-icon name="date"></icc-icon>
                            </div>
                            <div class="details-card__details-info">
                                <div class="details-card__details-row__header">
                                    <span *ngIf="change?.company?.length && change.author !== 'Klient'" class="details-card__company">{{ change.company }}</span>
                                    <span *ngIf="change?.company?.length && change.author === 'Klient'" class="details-card__company">{{ openedDocument.clientName }}</span>

                                    <span *ngIf="change.type === 'addComplaintNote' && change.value?.visibility" class="note-visibility">
                                        <icc-complaint-note-visibility [visibility]="change.value.visibility"></icc-complaint-note-visibility>
                                    </span>
                                </div>

                                <div class="details-card__details-row additional-spacing">
                                    <span class="details-card__change-time">
                                        {{ change.date | date: 'short' }},
                                    </span>
                                    <span class="details-card__change-author">
                                        {{ change.author.length ? change.author : '' }}
                                    </span>
                                </div>

                                <div class="details-card__details-row">
                                    <div class="details-card-body-description">

                                        <ng-container *ngIf="change.type === 'addComplaintNote'">
                                            <div class="note-container">
                                                <div *ngIf="change.title" class="note-title">
                                                    {{ change.title }}
                                                </div>
                                                <div class="note-description">
                                                    {{ change.description }}
                                                </div>
                                                <div *ngIf="change.value.replyId" class="note-quotation">
                                                    <div class="note-quotation__info">
                                                        {{ change.subtitle }}
                                                    </div>
                                                    <div class="note-quotation__content">
                                                        {{ change.quotedContent }}
                                                    </div>
                                                </div>
                                                <div class="note-attachments">
                                                    <div class="note-attachments-body image-attachments" *ngIf="getImageAttachments((complaintNoteAttachments$ | async)?.get(change.value.uuid)).length > 0">
                                                        <ng-container *ngFor="let attachment of getImageAttachments((complaintNoteAttachments$ | async)?.get(change.value.uuid))">
                                                            <div class="image-container">
                                                                <a
                                                                    [href]="'/complaint_attachments/' + attachment.uuid"
                                                                    target="_blank"
                                                                >
                                                                    <img
                                                                        [src]="'/complaint_attachments/' + attachment.uuid"
                                                                        [alt]="attachment.name"
                                                                    >
                                                                </a>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                    <div class="note-attachments-body pdf-attachments" *ngIf="getPdfAttachments((complaintNoteAttachments$ | async)?.get(change.value.uuid)).length > 0">
                                                        <ng-container *ngFor="let attachment of getPdfAttachments((complaintNoteAttachments$ | async)?.get(change.value.uuid))">
                                                            <div class="pdf-container">
                                                                <icc-icon name="pdf_file"></icc-icon>
                                                                <div class="filename">
                                                                    <a
                                                                        [title]="attachment.name"
                                                                        [href]="'/complaint_attachments/' + attachment.uuid"
                                                                        target="_blank"
                                                                    >
                                                                        {{ attachment.name }}
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <ng-container *ngIf="!change?.group?.length && change.type !== 'addComplaintNote'">
                                            <icc-icon name="done"></icc-icon>
                                            {{ change.title }}
                                            <span *ngIf="change?.html" [innerHTML]="change.description"></span>
                                            <ng-container *ngIf="!change?.html">
                                                {{ change.description ? ': ' + change.description : ((change.type === 'setField' || change.type === 'setPositionField') ? ': ' + ('COMPLAINT|Brak' | translate) : '' )}}
                                            </ng-container>
                                            <button *ngIf="change.type === 'addDoc'" class="details-card-body-button" iccButton appearance="outline" (click)="showDocumentFirstVersion(change)">
                                                {{ 'COMPLAINT|Pokaż pierwotną wersję' | translate }}
                                            </button>
                                            <button *ngIf="change.type === 'addAppointment'" class="details-card-body-button" iccButton appearance="outline" (click)="showAppointmentFirstVersion(change)">
                                                {{ 'COMPLAINT_APPOINTMENT|Pokaż pierwotną wersję wizyty' | translate }}
                                            </button>
                                        </ng-container>
                                        <ng-container *ngIf="change?.group?.length">
                                            <icc-icon name="done"></icc-icon>
                                            <ng-container *ngFor="let row of change.group">
                                                {{ row.title }}
                                                <span *ngIf="row?.html" [innerHTML]="row.description"></span>
                                                <ng-container *ngIf="!row?.html">
                                                    {{ row.description ? ': ' + row.description : ((change.type === 'setField' || change.type === 'setPositionField') ? ': ' + ('COMPLAINT|Brak' | translate) : '' )}}<br>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="details-card__actions">
                            <button
                                iccIconButton
                                (click)="replyToComplaintNote(openedDocument, change.value)"
                                [title]="'COMPLAINT|Odpowiedz' | translate"
                                appearance="flat"
                                *ngIf="change.type === 'addComplaintNote' && canReplyToNote(change) && (hasAccessTo.addComplaintNote || (hasAccessTo.addInternalNote && change.value.visibility === 'internal') || (hasAccessTo.addPrivateNote && change.value.visibility === 'private'))"
                            >
                                <icc-icon name="comment_quote"></icc-icon>
                            </button>
                        </div>

                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>

    <div id="document-actions">
        <div class="document-actions-bar document-actions-bar__left">
                <button
                    iccButton
                    appearance="outline"
                    (click)="backToList()"
                >
                    <icc-icon name="list"></icc-icon>
                    {{ navButtonLabel }}
                </button>
        </div>
        <div class="document-actions-bar document-actions-bar__right">
            <button
                *ngIf="hasAccessTo.appealToDistributor"
                iccButton
                appearance="primary"
                (click)="workflowButtonClicked('appeal_to_distributor')"
                [title]="'COMPLAINT|Odwołanie do dystrybutora' | translate"
            >
                {{ 'COMPLAINT|Odwołanie do dystrybutora' | translate }}
            </button>
            <button
                *ngIf="hasAccessTo.appealToManufacturer"
                iccButton
                appearance="primary"
                (click)="workflowButtonClicked('appeal_to_manufacturer')"
                [title]="'COMPLAINT|Odwołanie do producenta' | translate"
            >
                {{ 'COMPLAINT|Odwołanie do producenta' | translate }}
            </button>
            <button
                *ngIf="hasAccessTo.receivedFromManufacturer"
                iccButton
                appearance="primary"
                (click)="workflowButtonClicked('received_from_manufacturer')"
                [title]="'COMPLAINT|Otrzymano od producenta' | translate"
            >
                {{ 'COMPLAINT|Otrzymano od producenta' | translate }}
            </button>
            <button
                *ngIf="hasAccessTo.receivedFromDistributor"
                iccButton
                appearance="primary"
                (click)="workflowButtonClicked('received_from_distributor')"
                [title]="'COMPLAINT|Otrzymano od dystrybutora' | translate"
            >
                {{ 'COMPLAINT|Otrzymano od dystrybutora' | translate }}
            </button>
            <button
                *ngIf="hasAccessTo.partsSentAps"
                iccButton
                appearance="primary"
                (click)="workflowButtonClicked('parts_sent_aps')"
                [title]="'COMPLAINT|Części wysłane' | translate"
            >
                {{ 'COMPLAINT|Części wysłane' | translate }}
            </button>
            <button
                *ngIf="hasAccessTo.returnResignationAps"
                iccButton
                appearance="primary"
                (click)="workflowButtonClicked('return_resignation_aps')"
                [title]="'COMPLAINT|Rezygnuję ze zwrotu' | translate"
            >
                {{ 'COMPLAINT|Rezygnuję ze zwrotu' | translate }}
            </button>
            <button
                *ngIf="hasAccessTo.partsSentDistributor"
                iccButton
                appearance="primary"
                (click)="workflowButtonClicked('parts_sent_distributor')"
                [title]="'COMPLAINT|Części wysłane' | translate"
            >
                {{ 'COMPLAINT|Części wysłane' | translate }}
            </button>
            <button
                *ngIf="hasAccessTo.returnResignationDistributor"
                iccButton
                appearance="primary"
                (click)="workflowButtonClicked('return_resignation_distributor')"
                [title]="'COMPLAINT|Rezygnuję ze zwrotu' | translate"
            >
                {{ 'COMPLAINT|Rezygnuję ze zwrotu' | translate }}
            </button>

            <button
                *ngIf="selectedPositions.length > 0 && hasAccessTo.manageComplaint"
                iccButton
                appearance="primary"
                (click)="movePositionsToNewDocument()"
                [title]="'COMPLAINT|Przenieś pozycje do osobnego zgłoszenia' | translate"
            >
                <icc-icon name="copy"></icc-icon>
                {{ 'COMPLAINT|Przenieś wybrane pozycje' | translate }}
            </button>
        </div>
        <div *ngIf="splitNeeded() && hasAccessTo.manageComplaint" class="document-actions--blocked-actions">
            <div class="document-actions--blocked-message">
                <button
                    iccButton
                    appearance="flat-base"
                    (click)="showInfo()"
                >
                    <icc-icon name="info"></icc-icon>
                    {{ 'COMPLAINT|Dlaczego wymagany jest podział?' | translate }}
                </button>
            </div>
            <button
                iccButton
                appearance="outline"
                (click)="acceptChanges()"
                [title]="'COMPLAINT|Zatwierdź zmiany i przenieś pozycje do osobnych zgłoszeń' | translate"
            >
                <icc-icon name="done"></icc-icon>
                {{ 'COMPLAINT|Wymagany podział - zatwierdź zmiany' | translate }}
            </button>
        </div>
    </div>

</div>
